import API from '../api/api';
import { ApiRoutes } from '../constans/api';

export interface ITableRow {
  name: string;
  id: number;
  report_exist?: boolean;
  invited: number;
  completed: number;
  completed_ratio: number;
  not_completed: number;
  not_completed_ratio: number;
  internal_completed_ratio?: number;
  external_completed_ratio?: number;
}

export interface IResponseRateItem {
  value: string;
  count: number;
}

export interface IDashboardData {
  tableRows: ITableRow[];
  completionTimeline: [string, number][];
  responseRate: {
    valueCounts: IResponseRateItem[];
  };
}

export const getDashboardData = async (surveyId: string): Promise<IDashboardData> => {
  const { data } = await API.get(`${ApiRoutes.surveyList}${surveyId}/${ApiRoutes.surveyDashboard}`);
  return data;
};
